import type { FaireProductEntity } from "../../entity_types/product";

export const p_fwcdybgnrs: FaireProductEntity = {
  token: "p_fwcdybgnrs",
  type: "product",
  name: "Matches • Art • Birth of Venus • Home Decor for Candles",
  brandToken: "b_6zicjtg87q",
  brandName: "Most Amazing",
  imageUrl:
    "https://cdn.faire.com/fastly/a5e201dd3bdfcd30cd55e5382f91f2856ac429c7ad3d55364b35a492060bae0b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c863db0be7f056eb82319b2b6f6640e27ea1a2413b71f3d90556bea07dadc8ea.jpeg",
    "https://cdn.faire.com/fastly/0d36dfc98ab3b661f9f6ab8e1e3d8e1f1a94ea609bd2c422eaa4a2fd2bedddb8.jpeg",
  ],
  priceDollars: 1.66,
  description:
    "• Matches to elevate your home decor. Light your candles and incense with style.\n• These unique matchboxes feature the classic art Birth of Venus on both sides\n• Each box contains 20-23 matches and measures about  2.25”x1.5”x.5”\n\n• NOW AVAILABLE! - CUSTOMIZE a Matchbox with YOUR SHOP LOGO! https://www.faire.com/product/p_zdp5asfpuq",
  tags: [],
  msrpDollars: 3.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:55.006Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
